import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotRank from "./components/HotRank";
import GuaField from "./components/GuaField";
import FloorTimeline from "./components/FloorTimeline";
import Faq from "./components/Faq";
import About from "./components/About";
import Footer from "./components/Footer";
import ThreadModal from "./components/ThreadModal";
import type { Story } from "@/mocks/chigua";
import { hotList, faqs } from "@/mocks/chigua";

export default function Home() {
  const [keyword, setKeyword] = useState("");
  const [selected, setSelected] = useState<Story | null>(null);
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 480);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Navbar />

      <main>
        <Hero onSearch={setKeyword} />
        <HotRank />
        <GuaField keyword={keyword} onOpen={setSelected} />
        <FloorTimeline />
        <Faq />
        <About />
      </main>

      <Footer />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="回到顶部"
        className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl leading-none" />
      </button>

      {selected && <ThreadModal story={selected} onClose={() => setSelected(null)} />}

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebPage",
                "@id": "https://qjzmjy.cn/#webpage",
                "url": "https://qjzmjy.cn/",
                "name": "吃瓜吧 - 盖楼蹲帖追连瓜 楼层跟进新进展",
                "description": "吃瓜吧是盖楼蹲帖的吃瓜社区，瓜田热榜实时更新，正在蹲的瓜持续吃瓜，楼层跟进新进展。",
                "inLanguage": "zh-CN",
                "isPartOf": { "@id": "https://qjzmjy.cn/#website" },
              },
              {
                "@type": "FAQPage",
                "mainEntity": faqs.map((f) => ({
                  "@type": "Question",
                  name: f.q,
                  acceptedAnswer: { "@type": "Answer", text: f.a },
                })),
              },
              {
                "@type": "ItemList",
                "name": "今日瓜田热榜",
                "itemListElement": hotList.map((h) => ({
                  "@type": "ListItem",
                  position: h.rank,
                  name: h.title,
                })),
              },
            ],
          }),
        }}
      />
    </>
  );
}